import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Alerts from '../Alerts/Alerts';
import { LoadingAlert } from '../LoadingView/LoadingView';
import Spinner from '../../../../CommonComponents/Spinner';
import {
  isUnarchivingAlertSelector,
  isFetchingArchivedAlertsSelector,
  isFetchingMoreArchivedAlertsSelector,
} from '../../../ExperianSelector';
import { getArchivedAlerts } from '../../../ExperianActions';
import { hasMoreArchivedAlertsSelector } from '../../ReportsSelector';
import { Card, CardHeader, Content, Title, ShowMoreButton } from '../Alerts/AlertsStyles';
import ExperianContext from '../../../ExperianContext';

const ArchivedAlerts = ({ alerts }) => {
  const [showAlerts, setShowAlerts] = useState(false);

  const isUnarchivingAlert = useSelector(isUnarchivingAlertSelector);
  const isFetchingArchivedAlerts = useSelector(isFetchingArchivedAlertsSelector);
  const isFetchingMoreArchivedAlerts = useSelector(isFetchingMoreArchivedAlertsSelector);
  const hasMoreArchivedAlerts = useSelector(hasMoreArchivedAlertsSelector);

  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();

  return (
    <>
      <Card>
        {isUnarchivingAlert && <Spinner />}

        <CardHeader onClick={() => setShowAlerts(!showAlerts)}>
          <Title>Archived Alerts</Title>
        </CardHeader>

        {showAlerts && (
          <Content>
            {isFetchingArchivedAlerts ? (
              <>
                <LoadingAlert />
                <LoadingAlert />
                <LoadingAlert />
                <LoadingAlert />
                <LoadingAlert />
              </>
            ) : (
              <Alerts alerts={alerts} isArchived />
            )}
            {isFetchingMoreArchivedAlerts && <LoadingAlert />}
          </Content>
        )}
      </Card>

      {hasMoreArchivedAlerts && !isFetchingMoreArchivedAlerts && showAlerts && (
        <ShowMoreButton
          onClick={() =>
            dispatch(getArchivedAlerts(clientId, subscriberId, alerts[alerts.length - 1].AlertId))
          }
          disabled={isFetchingMoreArchivedAlerts}
        >
          See more archived alerts
        </ShowMoreButton>
      )}
    </>
  );
};

ArchivedAlerts.propTypes = {
  alerts: PropTypes.arrayOf(
    PropTypes.shape({
      AlertId: PropTypes.string,
    }),
  ).isRequired,
};

export default ArchivedAlerts;
